import { CommandItem, CommandList } from "@/components/shadcn/command";
import type { DrugSuggestionGroup } from "@/hooks/use-drug-suggestions";
import { buildFlatRows } from "@/components/search/suggestion-rows";
import { SuggestionRow } from "@/components/search/suggestion-row";
import {
  DropdownError,
  DropdownLoading,
} from "@/components/search/dropdown-states";

export function DrugSuggestionDropdown({
  groups,
  query,
  loading,
  error,
  onCommit,
  onRetry,
  onFreeTextSearch,
}: {
  groups: DrugSuggestionGroup[];
  query: string;
  loading: boolean;
  error: boolean;
  onCommit: (submit: string, label: string) => void;
  onRetry: () => void;
  onFreeTextSearch: () => void;
}) {
  if (error) {
    return <DropdownError onRetry={onRetry} />;
  }

  if (loading && groups.length === 0) {
    return <DropdownLoading />;
  }

  const rows = buildFlatRows(groups);
  const shownQuery = query.trim();

  return (
    <CommandList className="max-h-[min(20rem,45dvh)]">
      {rows.length === 0 ? (
        // No match never hides silently: the raw search is a real cmdk item,
        // so Enter commits it like any row.
        <CommandItem
          value="free-text"
          onSelect={onFreeTextSearch}
          className="flex min-h-11 items-start border-l-2 border-l-transparent px-3 py-2 data-[selected=true]:border-l-brand data-[selected=true]:bg-accent"
        >
          <span className="flex min-w-0 flex-1 flex-col gap-1">
            <span className="text-sm font-semibold text-foreground">
              Szukaj „{shownQuery}” mimo to
            </span>
            <span className="text-sm text-muted-foreground">
              Nie znaleźliśmy „{shownQuery}” w rejestrze.
            </span>
          </span>
        </CommandItem>
      ) : (
        rows.map((row, i) => (
          <SuggestionRow
            key={row.key}
            row={row}
            value={`r${i}`}
            query={query}
            onCommit={onCommit}
          />
        ))
      )}
    </CommandList>
  );
}
